import { useEffect, useState } from 'react';
import './modules.css';
import { get, getPhotosBaseUrl } from '../../services/api';
import { useUI } from '../../UIContext';
import { handleErr } from '../../utils/functions';
import Photo from '../../components/Photo';
import Icon from '../../components/Icon';
import { useNavigate } from 'react-router-dom';

function Modules() {
    const [pageLoaded, setPageLoaded] = useState(false);
    const { setLoading, setMessage } = useUI();
    const [modules, setModules] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        async function getModules() {
            setLoading(true);

            await get('/module/contain-class', true, setMessage,
                async (response) => {
                    setModules(response.data);
                },
                (err) => {
                    handleErr(setMessage, `Não foi possível carregar os módulos: ${err}`);
                },
                () => {
                    setLoading(false);
                    setPageLoaded(true);
                }
            )
        }

        getModules();
    }, [setLoading, setMessage, setModules]);

    if (!pageLoaded)
        return;

    function getImageName(module) {
        if (!module.imagePath)
            return undefined;

        const imagePathSplitted = module.imagePath.split('/');
        return imagePathSplitted[imagePathSplitted.length - 1];
    }

    const principalModules = modules.filter(m => !m.supplementary);
    const supplementaryModules = modules.filter(m => m.supplementary);

    return (
        <>
            <div className='glass-bg-full-page'></div>
            <div className='principal-modules container-module-page'>
                <h1>Módulos Principais</h1>
                <h3>Explore os módulos do seu curso de turismo privativo.</h3>
                <div className='container-modules'>
                    {principalModules.map((m) => (
                        <div
                            className={`container-module zoom-effect ${!m.hasPermission ? 'container-module-locked' : ''}`}
                            key={m.id}
                            onClick={() => { navigate(`/module/${m.id}`) }}
                        >
                            <div className='container-module-photo'>
                                <Photo
                                    width='260px'
                                    height='160px'
                                    photo={`${getPhotosBaseUrl()}/modules/${getImageName(m)}`}
                                />
                                {!m.hasPermission && (
                                    <div className='container-module-padlock'>
                                        <Icon iconClass='icon-padlock-default' size={32} />
                                    </div>
                                )}
                            </div>
                            <h1>{m.name}</h1>
                        </div>
                    ))}
                </div>
            </div>

            <div className='container-module-page'>
                {supplementaryModules.length > 0 && <h1>Módulos Auxiliares</h1>}
                <div className='container-modules'>
                    {supplementaryModules.map((m) => (
                        <div
                            className={`container-module zoom-effect ${!m.hasPermission ? 'container-module-locked' : ''}`}
                            key={m.id}
                            onClick={() => { navigate(`/module/${m.id}`) }}
                        >
                            <div className='container-module-photo'>
                                <Photo
                                    width='260px'
                                    height='160px'
                                    photo={`${getPhotosBaseUrl()}/modules/${getImageName(m)}`}
                                />
                                {!m.hasPermission && (
                                    <div className='container-module-padlock'>
                                        <Icon iconClass='icon-padlock-default' size={32} />
                                    </div>
                                )}
                            </div>
                            <h1>{m.name}</h1>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}

export default Modules;